import { Component, OnInit, Input, Output, EventEmitter , OnDestroy} from '@angular/core';
import { Location } from '@angular/common';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Package } from './library';
import { SharedDataService } from '../../../shared/services/shared-data.service';
import { ToastrService } from 'ngx-toastr';
import * as api from '../../../shared/api/apihandler';
import { SubscriptionObject } from 'app/shared/models/standard.models';

@Component({
  selector: 'app-library',
  templateUrl: './library.component.html',
  styleUrls: ['./library.component.css']
})
export class LibraryComponent implements OnInit, OnDestroy {

  @Input('mode') mode: 'offer' | 'library' = 'library';
  @Input('companyInformation') companyInfo;
  @Input('currency') c = 'DKK'
  @Output('selectPackage') selectPackage = new EventEmitter();

  accessedFromSettings = false;
  params;
  libraryPartners;
  companyCategories;
  categories;
  categoryPackages;
  packageDetails: Package;
  showPartners = true;
  showPackages = false;
  showDetails = false;
  selectedPartner;
  selectedCategories = [];
  selectedPackages = [];
  categoriesOfSelectedPackages = [];
  selectedSkill;
  skills;
  priceGroups;
  selectedPriceGroup;
  importToCategory = [];
  activeCompany;
  activeCategory;
  activePackage;
  newCategory = false;
  packageChosen = false;
  subs: SubscriptionObject = {}

  constructor(private httpClient: HttpClient, private toastr: ToastrService, private sharedData: SharedDataService, private location: Location) {
    //this.route.queryParams.subscribe((params) => { this.params = params; console.log(params) });
    
  }

  ngOnInit() {
    if (this.location.path().includes('Settings')) { this.accessedFromSettings = true }
    this.subs['companyInformation'] = this.sharedData.companyInformation().subscribe(data => { this.companyInfo = data; });
    this.subs['categories'] = this.sharedData.categories().subscribe(data => { this.companyCategories = data; });
    this.subs['skills'] = this.sharedData.skills().subscribe(data => { this.skills = data; if (!!this.skills) { this.selectedSkill = this.skills[0].skillId } });
    this.subs['priceGroups'] = this.sharedData.priceGroups().subscribe(data => { this.priceGroups = data; if (!!this.priceGroups) { this.selectedPriceGroup = this.priceGroups.find(x => x.name == 'Standard').priceGroupId } });
    this.packageDetails = new Package();
    this.getLibraryPartners();
  }

  ngOnDestroy(): void {
    for(let key of Object.keys(this.subs)) this.subs[key].unsubscribe();
  }

  showUpdate(value: string, text: string, status: string) {
    if (status == 'error') {
      this.toastr.error(value);
    } else if (status == 'success') {
      this.toastr.success(text, value);
    }
  }

  getLibraryPartners() {
    const headers = new HttpHeaders({ 'Authorization': localStorage.getItem('bearer') });
    this.httpClient.get(api.jubloApi + 'api/PartnerLibrary/GetPackageLibraryPartners', { headers }).subscribe((data: any) => {
      this.libraryPartners = data.filter(x => x.companyId != '67b3474c-9ab5-4aee-bb22-043d7f886f4c');
      //console.log(this.libraryPartners);
    }, () => { }, () => {

    });
  }

  getCategories(id, name) {
    this.selectedPartner = name;
    //console.log(this.selectedPartner);
    const headers = new HttpHeaders({ 'Authorization': localStorage.getItem('bearer') });
    this.httpClient.get(api.jubloApi + 'api/PartnerLibrary/GetCategories/' + id, { headers }).subscribe((data: any) => {
      this.categories = data.filter(x => x.packageCount > 0);
      for (let x of this.categories) {
        x['visible'] = false;
      }
    }, () => { }, () => {
      this.showPartners = false;
    });
  }

  async getPackages(id): Promise<any> {
    const headers = new HttpHeaders({ 'Authorization': localStorage.getItem('bearer') });
    this.httpClient.get(api.jubloApi + 'api/PartnerLibrary/GetPackageOverView/' + id, { headers }).subscribe((data: any) => {
      this.categoryPackages = data;
      //console.log(this.categoryPackages);
    }, () => { }, async () => {
      if (this.categoryPackages.length > 0) {
        this.showPackages = true;
      }
      return await this.categoryPackages;
    });
  }

  getPackage(id) {
    const headers = new HttpHeaders({ 'Authorization': localStorage.getItem('bearer') });
    this.httpClient.get(api.jubloApi + 'api/PartnerLibrary/GetPackageDetails/' + id, { headers }).subscribe((data: Package) => {
      this.packageDetails = data;
      //console.log(this.packageDetails);
    }, () => { }, () => {
      if (!!this.packageDetails) {
        this.showDetails = true;
        }
      this.packageChosen = true;
    });
  }

  async chooseCategory(id) {
    if (this.selectedCategories.includes(id)) {
      this.selectedCategories = this.selectedCategories.filter(x => x != id);
      this.selectedPackages = this.selectedPackages.filter(x => x.categoryId != id);
    } else {
      this.selectedCategories.push(id);
      const headers = new HttpHeaders({ 'Authorization': localStorage.getItem('bearer') });
      this.httpClient.get(api.jubloApi + 'api/PartnerLibrary/GetPackageOverView/' + id, { headers }).subscribe((data: any) => {
        this.categoryPackages = data;
      }, () => { }, () => {
          for (let x of this.categoryPackages) {
            const headers = new HttpHeaders({ 'Authorization': localStorage.getItem('bearer') });
            this.httpClient.get(api.jubloApi + 'api/PartnerLibrary/GetPackageDetails/' + x.packageId, { headers }).subscribe((data: Package) => {
              let tempData = {
                packageId: data.packageId,
                categoryId: data.categoryId,
                skillId: '',
                priceGroupId: '',
                packageUpdateType: '1fc7e7e0-c226-4d09-84ae-e56fab0000c9'
              };
              if (!this.selectedPackages.find(y => y.packageId == x.packageId)) {
                this.selectedPackages.push(tempData);
              }
            }, () => { }, () => {
            });
          }
      });
    }
    
  }

  isPackageSelected(id) {
    if (this.selectedPackages.find(x => x.packageId == id)) {
      return true;
    } else {
      return false;
    }
  }

  choosePackages(x) {
    if (this.selectedPackages.find(y => y.packageId == x.packageId)) {
      this.selectedPackages = this.selectedPackages.filter(y => y.packageId != x.packageId);
    } else {
      const headers = new HttpHeaders({ 'Authorization': localStorage.getItem('bearer') });
      this.httpClient.get(api.jubloApi + 'api/PartnerLibrary/GetPackageDetails/' + x.packageId, { headers }).subscribe((data: Package) => {
        let tempData = {
          packageId: data.packageId,
          categoryId: data.categoryId,
          skillId: '',
          priceGroupId: '',
          packageUpdateType: '1fc7e7e0-c226-4d09-84ae-e56fab0000c9'
        };
        this.selectedPackages.push(tempData);
      }, () => { }, () => {
      });
    }
    console.log(this.selectedPackages);
  }


  async prepareCopy() {
    this.importToCategory = [];
    let cat = await this.getSelectedCategories();
    for (let x of cat) {
      this.importToCategory.push({ name: this.categories.find(y => y.categoryId == x).categoryName, partnerCategoryId: this.categories.find(y => y.categoryId == x).categoryId, companyCategoryId: "", newCategory: false, newCategoryName: "" });
    }
  }

  addNewCategory(id) {
    const headers = new HttpHeaders({ 'Authorization': localStorage.getItem('bearer') });
    this.httpClient.post(api.jubloApi + 'api/PackageDistributor/Create',
      {
        "description": this.importToCategory[id].newCategoryName,
        "name": this.importToCategory[id].newCategoryName,
        "parentCategoryId": null,
        "image": "6dfe2e19-3e01-4d7e-9cf6-24660c0d4d80"
      },
      { headers }).subscribe(
        (val: any) => { this.importToCategory[id].companyCategoryId = val.categoryId },
        response => { },
        () => { this.sharedData.updateCategories(); this.importToCategory[id].newCategory = false; this.importToCategory[id].newCategoryName = ''; }
      );
  }

  validator() {
    for (let x of this.importToCategory) {
      if (x.companyCategoryId == "") {
        return true;
      } else {
        return false;
      }
    }
  }

  async getSelectedCategories() {
    let a = new Set();
    for (let x of this.selectedPackages) {
      a.add(x.categoryId);
    }
    return Array.from(a);
  }

  startPackageTransfer() {
    for (let x of this.selectedPackages) {
      x.categoryId = this.importToCategory.find(y => y.partnerCategoryId == x.categoryId).companyCategoryId;
      x.priceGroupId = this.selectedPriceGroup;
      x.skillId = this.selectedSkill;
    }
    this.copyPackages();
  }

  copyPackages() {
    const headers = new HttpHeaders({ 'Authorization': localStorage.getItem('bearer') });
    this.httpClient.post(api.jubloApi + 'api/PartnerLibrary/CopyPackages', this.selectedPackages,
      { headers }).subscribe(
        val => { /*console.log(val);*/ },
        err => {
          this.showUpdate('Kunne ikke kopiere pakker', err, 'error');
        },
        () => {
          this.showUpdate('Kopierer pakker', this.selectedPackages.length.toString() + ' pakker', 'success');
        }
      );
  }

  packageToOffer() {
    this.selectPackage.emit(this.packageDetails.packageId);
    this.categories = null;
    this.activeCompany = null;
    this.categoryPackages = null;
    this.activePackage = null;
    this.showDetails = false;
    this.packageDetails = null;
  }


  priceCalc(price) {
    if (!!price && !!this.companyInfo) {
      return new Intl.NumberFormat(this.companyInfo.companyLanguage, {
        style: 'currency',
        currency: this.c,
        minimumFractionDigits: 2,
        maximumFractionDigits: 2,
      }).format(price);
    }
    else { return '' }
  }

}

